import { extend } from "umi-request";
import { Message } from "@alifd/next";
import queryString from "query-string";
import deviceFactor from "../utils/device-factor";
import { urlPrefix } from '../adapter/request';

const appendHeader = window.G_GOV_MESSAGE?.appendHeader || [
  {
    key: "guc-endpoint",
  },
  {
    key: "guc-accountType",
  },
  {
    key: "access_token",
  },
  {
    key: "auth_type",
  },
  // {
  //   key: "x-gov-tenant",
  //   defaultValue: "baseline",
  // },
];

const getQuery = () => {
  const match = window.location.href.match(/\?(.*)$/);
  const search = match ? match[1] : "";
  const query = queryString.parse(search, {
    parseBooleans: true,
  });
  return query;
};

export const getAppendHeader = (config = appendHeader) => {
  const currentQuery = getQuery();
  const rv = {};
  if (Array.isArray(config)) {
    config.forEach((c) => {
      const { key, defaultValue } = c || {};
      if (key && (currentQuery?.[key] || defaultValue)) {
        rv[key] = currentQuery?.[key] || defaultValue;
      }
    });
  }
  return rv;
};

const request = extend({
  prefix: urlPrefix(),
  timeout: 20 * 1000, // 设置超时时间 20s
  errorHandler: () => {
    Message.error("抱歉，网络异常，请稍后再试。");
  },
});

// response拦截器, 处理response
request.interceptors.response.use(async (response, options) => {
  const data = await response.clone().json();
  if (data && data.errorCode === "401") {
    let currentUrl = location.href.toString();
    if (window.top !== window.self) {
      // 在 iframe 中
      // 默认跳到大汉首页
      currentUrl = document.referrer;
    }
    window.top.location.href = `${data.data}&goto=${encodeURIComponent(
      currentUrl
    )}`;
    return false;
  }
  if (data.success) {
    // TODO
  } else if (
    !options ||
    !options.extraOptions ||
    options.extraOptions.autoShowError !== false
  ) {
    let errMsg = data.errorMsg;
    if (data.extraData && data.extraData.length) {
      data.extraData.forEach((err) => {
        errMsg += `\n${err.errorMsg}`;
      });
    }
    if (errMsg && errMsg !== "") {
      Message.error(errMsg);
    }
  }
  return response;
});

const f = (params) => {
  const { url, ...rest } = params;
  const appendHeader = getAppendHeader();

  rest.headers = {
    ...appendHeader,
    ...rest.headers,
    channel: "pc",
    ...deviceFactor(),
  };

  return request(url, rest);
};

export default f;
